const testIdPrefix = 'student-filters'

export const testIDs = {
  diplomaSeekingDropdown: `${testIdPrefix}-diploma-seeking-dropdown`,
}
